import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import logo from '/logo.svg';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const isHomePage = location.pathname === '/';
  const isHeroSection = location.pathname === '/';
  const isContact = location.pathname === '/contact';

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isVisible = prevScrollPos > currentScrollPos || currentScrollPos < 10;

      setPrevScrollPos(currentScrollPos);
      setVisible(isVisible);
      setHasScrolled(currentScrollPos > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      if (isNavOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }

      return () => {
        document.body.style.overflow = 'visible';
      };
    }
  }, [isNavOpen]);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleContactClick = () => {
    document.getElementById('footer').scrollIntoView({ behavior: 'smooth' });
    toggleNav();
    setTimeout(() => {
      document.body.style.overflow = 'visible';
    }, 500);
  };

  const hamburgerClass = `${styles.hamburger} ${isNavOpen ? styles.open : ''} ${isHomePage && !isNavOpen && !hasScrolled ? styles.white : ''}`;

  return (
    <header
      className={`${styles.header} ${visible ? styles.visible : styles.hidden} ${hasScrolled ? styles.scrolled : ''} ${isHomePage ? styles.homePage : ''} ${isNavOpen ? styles.navOpen : ''}`}
      role="banner"
    >
      <div className={styles.headerContent} role="navigation" aria-label="Main Navigation">
        <div className={styles.logo}>
          <Link to="/" className={styles.logo} tabIndex="0">
            <img src={logo} alt="BGRS Logo" className={`${styles.logoImage} ${isHomePage && !hasScrolled && !isNavOpen ? styles.whiteLogo : ''}`} />
          </Link>
        </div>

        <div
          className={hamburgerClass}
          onClick={toggleNav}
          onKeyPress={(e) => e.key === 'Enter' && toggleNav()}
          role="button"
          tabIndex="0"
          aria-label="Toggle Navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`${styles.nav} ${isNavOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            <li>
              <Link
                to="/"
                className={location.pathname === '/' ? styles.activeLink : ''}
                onClick={toggleNav}
                tabIndex="0"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={location.pathname === '/about' ? styles.activeLink : ''}
                onClick={toggleNav}
                tabIndex="0"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="#"
                onClick={handleContactClick}
                className={location.pathname === '/contact' ? styles.activeLink : ''}
                tabIndex="0"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/faqs"
                className={location.pathname === '/faqs' ? styles.activeLink : ''}
                onClick={toggleNav}
                tabIndex="0"
              >
                FAQs
              </Link>
            </li>
          </ul>
          {!isHeroSection && !isContact && (
            <button
              className={styles.quoteButton}
              onClick={() => { navigate('/contact'); toggleNav(); }}
              tabIndex="0"
              onKeyPress={(e) => e.key === 'Enter' && navigate('/contact')}
            >
              Get a Free Quote
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;